import { ScrollReveal } from "@/components/motion/ScrollReveal";

export const SectionHeading = ({ eyebrow, title, intro, align = "left", testId }) => {
  const center = align === "center";
  return (
    <ScrollReveal className={center ? "max-w-3xl mx-auto text-center" : "max-w-3xl"} y={16}>
      {eyebrow && (
        <div
          className={`flex items-center gap-3 mb-5 ${center ? "justify-center" : ""}`}
          data-testid={testId ? `${testId}-eyebrow` : undefined}
        >
          <span className="h-px w-8 bg-[var(--blue)]" />
          <span className="eyebrow">{eyebrow}</span>
        </div>
      )}
      <h2
        className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.08] text-[var(--white)]"
        data-testid={testId}
      >
        {title}
      </h2>
      {intro && (
        <p className="mt-5 text-base md:text-lg text-muted leading-relaxed" data-testid={testId ? `${testId}-intro` : undefined}>{intro}</p>
      )}
    </ScrollReveal>
  );
};
